import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";

const STATUS_COLOR = {
  ACTIVE: "text-chessup-turq", TRIALING: "text-chessup-turq", ADMIN_GRANTED: "text-chessup-goldlight",
  PAST_DUE: "text-red-300", CANCELED: "text-chessup-subtext", EXPIRED: "text-chessup-subtext", FREE: "text-chessup-subtext",
};

export default function AdminStudents() {
  const [students, setStudents] = useState([]);
  const [grant, setGrant] = useState(null);
  const [days, setDays] = useState(30);
  const [reason, setReason] = useState("");

  const load = () => api.get("/admin/students").then(({ data }) => setStudents(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const doGrant = async () => {
    await api.post(`/admin/students/${grant.id}/grant`, { days: parseInt(days), reason });
    toast.success("Acesso concedido"); setGrant(null); setReason(""); load();
  };

  return (
    <div className="p-5 sm:p-8">
      <h1 className="font-heading text-3xl text-chessup-text mb-6">Alunos</h1>
      <div className="rounded-xl border border-chessup-border bg-chessup-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-chessup-subtext border-b border-chessup-border">
            <th className="p-3">Nome</th><th className="p-3">E-mail</th><th className="p-3">Nível</th><th className="p-3">XP</th><th className="p-3">Aulas</th><th className="p-3">Assinatura</th><th className="p-3">Cadastro</th><th className="p-3"></th>
          </tr></thead>
          <tbody>
            {students.map((s) => (
              <tr key={s.id} className="border-b border-chessup-border/40 text-chessup-text" data-testid={`admin-student-${s.id}`}>
                <td className="p-3">{s.name}</td><td className="p-3 text-chessup-subtext">{s.email}</td>
                <td className="p-3">{s.level}</td><td className="p-3">{s.xp}</td><td className="p-3">{s.lessons_completed}</td>
                <td className={`p-3 ${STATUS_COLOR[s.subscription_status] || ""}`}>{s.subscription_status}</td>
                <td className="p-3 text-chessup-subtext">{formatDate(s.created_at)}</td>
                <td className="p-3"><button onClick={() => setGrant(s)} className="rounded-lg bg-chessup-gold/15 text-chessup-goldlight px-3 py-1.5 text-xs">Conceder acesso</button></td>
              </tr>
            ))}
            {!students.length && <tr><td colSpan={8} className="p-8 text-center text-chessup-subtext">Nenhum aluno cadastrado ainda.</td></tr>}
          </tbody>
        </table>
      </div>

      {grant && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setGrant(null)}>
          <div className="w-full max-w-sm rounded-2xl border border-chessup-border bg-chessup-card p-6" onClick={(e) => e.stopPropagation()}>
            <h2 className="font-heading text-xl text-chessup-text mb-1">Conceder acesso</h2>
            <p className="text-sm text-chessup-subtext mb-4">{grant.name} · {grant.email}</p>
            <label className="text-xs text-chessup-subtext">Período</label>
            <select className="w-full rounded-lg bg-chessup-deep border border-chessup-border px-3 py-2 text-sm text-chessup-text mb-3 mt-1" value={days} onChange={(e) => setDays(e.target.value)}>
              <option value={7}>7 dias</option><option value={30}>30 dias</option><option value={90}>90 dias</option>
            </select>
            <label className="text-xs text-chessup-subtext">Motivo</label>
            <input className="w-full rounded-lg bg-chessup-deep border border-chessup-border px-3 py-2 text-sm text-chessup-text mt-1 mb-4" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Ex: bolsa, parceria..." />
            <div className="flex gap-2">
              <button onClick={doGrant} className="flex-1 rounded-full bg-chessup-gold py-2.5 text-sm font-semibold text-chessup-deep">Conceder</button>
              <button onClick={() => setGrant(null)} className="rounded-full border border-chessup-border px-5 py-2.5 text-sm text-chessup-text">Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
